import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './redux-toolkit/store/store';
import './utilities/axiosInterceptor';
import "tw-elements-react/dist/css/tw-elements-react.min.css";
import { BrowserRouter } from 'react-router-dom';

// The codebase has 1600+ console.log calls on hot paths (renders, requests).
// Logging serializes objects and badly slows the app when DevTools is open —
// silence noisy log levels in production; warnings and errors stay visible.
if (process.env.NODE_ENV === 'production') {
  const noop = () => { };
  console.log = noop;
  console.debug = noop;
  console.info = noop;
}
// import '../src/style/datatables.css';
// import '../src/style/datatables.min.css';
// import '../src/script/datatables'
// import '../src/script/datatables.min'
// import '../src/script/PrintButton'
// import '../src/script/buttonsDataTable'
// import '../src/script/dataTable'
// import '../src/script/dataTablebuttons'
// import '../src/script/htmlfive'
// import '../src/script/jsZip'
// import '../src/script/pdfMake'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <App />
    </BrowserRouter>
  </Provider>,
);

